<div class="list-paginator" [class.list-paginator--busy]="busy()">
  @if (includeAllOption()) {
    <div class="list-paginator__page-size">
      <label class="list-paginator__page-size-label" for="list-paginator-page-size">Items per page:</label>
      <select
        id="list-paginator-page-size"
        class="list-paginator__page-size-select"
        [value]="selectValue()"
        [disabled]="busy()"
        (change)="onPageSizeChange($any($event.target).value)"
        aria-label="Items per page"
      >
        @for (opt of pageSizeOptions(); track opt) {
          <option [value]="opt">{{ opt }}</option>
        }
        <option [value]="allPageSize">All</option>
      </select>
    </div>
  }

  <mat-paginator
    (page)="onPage($event)"
    [length]="length()"
    [pageSize]="effectivePageSize()"
    [pageIndex]="pageIndex()"
    [pageSizeOptions]="pageSizeOptions()"
    [hidePageSize]="includeAllOption()"
    [attr.aria-label]="ariaLabel()"
  />
</div>
